"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DepositSuccess = function (_a) {
    var _b = _a.showSuccessDepositBonus, showSuccessDepositBonus = _b === void 0 ? true : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var closeModal = (0, apps_shared_1.useCloseModal)(true);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "0", saveSize: true },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.icon },
                    react_1.default.createElement(image_1.default, { src: "/img/depositStatuses/success.svg", width: 40, height: 40, alt: "success" })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t("successDepositStatusTitle")),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('successDepositStatusMessage')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                    react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", maxWidth: "320px", text: "upper", onClick: closeModal }, t("continue")))))));
};
exports.default = DepositSuccess;
